<template>
  <v-layout wrap>
    <v-flex
      sm2
      md2
    >
      <v-text-field
        v-model="currentUser.id"
        label="User ID"
        disabled
      />
    </v-flex>
    <v-flex md5>
      <v-text-field
        v-model="currentUser.email"
        label="Email"
        disabled
      />
    </v-flex>

    <v-flex md6>
      <v-text-field
        v-model="formData.firstName"
        label="First name"
        :error-messages="getFieldErrors('firstName')"
        @change="$v.formData.firstName.$touch()"
        @blur="$v.formData.firstName.$touch()"
      />
    </v-flex>
    <v-flex md6>
      <v-text-field
        v-model="formData.lastName"
        label="Last name"
        :error-messages="getFieldErrors('lastName')"
        @change="$v.formData.lastName.$touch()"
        @blur="$v.formData.lastName.$touch()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ExternalIdentFormFields',
  props: {
    currentUser: {
      type: Object,
      default: null,
      required,
    },
    provider: {
      type: String,
      required,
      default: null,
    },
    onSubmit: {
      type: Function,
      required,
      default: null,
    },
  },

  data: () => ({
    search: '',
    pickerBirthDateOpen: false,
    pickerDocDateOpen: false,
    error: null,
    formData: {
      provider: this.provider,
      userId: null,
      lastName: null,
      firstName: null,
    },
  }),

  validations() {
    return {
      formData: {
        provider: { required },
        userId: { required },
        lastName: { required },
        firstName: { required },
      },
    };
  },
  computed: {
    validFields() {
      return Object.keys(this.$v.formData.$params).filter(
        item => !this.$v.formData[item].$invalid,
      );
    },
    errors() {
      return Object.keys(this.$v.formData.$params).filter(
        item => this.$v.formData[item].$invalid,
      );
    },
  },
  watch: {
    provider() {
      this.updateProvider();
    },
  },
  mounted() {
    this.mapUserData();
    this.updateProvider();
  },
  methods: {
    updateProvider() {
      this.formData.provider = this.provider;
    },
    getFieldErrors(field) {
      const errors = [];
      if (this.$v.formData[field]) {
        if (!this.$v.formData[field].$dirty) {
          return errors;
        }
        if (!this.$v.formData[field].required) {
          errors.push('Required field');
        }
      }

      return errors;
    },

    mapUserData() {
      // POST IDENT / IDNOW FORM DATA
      this.formData.userId = this.currentUser.id;
      this.formData.firstName = this.currentUser.first_name;
      this.formData.lastName = this.currentUser.last_name;
    },

    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.onSubmit(this.formData);
      }
    },
  },
};
</script>

<style lang="scss" >
</style>



// WEBPACK FOOTER //
// src/components/ident/dialog/create/ExternalIdentFormFields.vue